const ACE_V2_URL = process.env.REACT_APP_ACE_V2_URL || 'https://ace.odin-vision.com';
const COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN || '.odin-vision.com';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export function getAceVersionCookie() {
    const match = document.cookie.match(/(?:^|; )ace_version=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : null;
}

export function switchToAceV2(path) {
    document.cookie = `ace_version=v2; Domain=${COOKIE_DOMAIN}; Path=/; Secure; SameSite=Lax; Max-Age=${COOKIE_MAX_AGE}`;
    window.location.href = `${ACE_V2_URL}${path || ''}`;
}

export { ACE_V2_URL, COOKIE_DOMAIN };
